import React from "react";
import { Button, Container, Menu, Image, Header } from "semantic-ui-react";
import { Route, Link } from "react-router-dom";

const style = {
  MakeItem: {
    paddingTop: 0,
    paddingBottom: 0
  }
};

const AppHeaderDestop = () => (
  <Menu pointing secondary size="large" color="pink" className="navbar">
    <Container>
      <Link to="/">
        <Menu.Item header style={{ paddingBottom: 0 }}>
            <Image
              size="mini"
              src="/logo_256.png"
              style={{ marginRight: "1.5em" }}
            />
            <Header size="medium">
              Custom Book
            </Header>
        </Menu.Item>
      </Link>

      <Route
      path="/"
      exact
      children={({ match }) =>
        (<Menu.Item position="right" active={!!match}>
          <Link to="/">
            Home
          </Link>
        </Menu.Item>)}
      />

      <Route
      path="/pricing"
      children={({ match }) =>
        (<Menu.Item active={!!match}>
          <Link to="/pricing">
            Pricing
          </Link>
        </Menu.Item>)}
      />

      <Menu.Item style={style.MakeItem}>
        <Link to="/new">
          <Button basic color="black">
            Make a Book
          </Button>
        </Link>
      </Menu.Item>
    </Container>
  </Menu>
);

export default AppHeaderDestop;
